import React from "react";
import styled from "styled-components";

import { FAQ } from "../../../constants/faq";

import BasicHeaderSection from "../../sections/BasicHeaderSection";
import PricingSection from "../../sections/PricingSection";
import FAQSection from "../../sections/FAQSection";
import TitleSectionFederal from "../../V2-federal/sections/TitleSection";
import PricingSectionFederal from "../../V2-federal/sections/PricingSection";
import TitleSectionReflection1 from "../../V2-reflection-1/sections/TitleSection";
import PricingSectionReflection1 from "../../V2-reflection-1/sections/PricingSection";
import TitleSectionReflection2 from "../../V2-reflection-2/sections/TitleSection";
import PricingSectionReflection2 from "../../V2-reflection-2/sections/PricingSection";
import TitleSectionReflection3 from "../../V2-reflection-3/sections/TitleSection";
import PricingSectionReflection3 from "../../V2-reflection-3/sections/PricingSection";
import TitleSectionReflection4 from "../../V2-reflection-4/sections/TitleSection";
import PricingSectionReflection4 from "../../V2-reflection-4/sections/PricingSection";

const StyledPricingPage = styled.div``;

function PricingPage() {
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
    return (
      <StyledPricingPage>
        <TitleSectionFederal title="Plans and Pricing" />
        <PricingSectionFederal />
      </StyledPricingPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <StyledPricingPage>
        <TitleSectionReflection1 title="Plans and Pricing" />
        <PricingSectionReflection1 />
      </StyledPricingPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <StyledPricingPage>
        <TitleSectionReflection2 title="Plans and Pricing" />
        <PricingSectionReflection2 />
      </StyledPricingPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <StyledPricingPage>
        <TitleSectionReflection3 title="Plans and Pricing" />
        <PricingSectionReflection3 />
      </StyledPricingPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <StyledPricingPage>
        <TitleSectionReflection4 title="Plans and Pricing" />
        <PricingSectionReflection4 />
      </StyledPricingPage>
    );
  }
  return (
    <StyledPricingPage>
      <BasicHeaderSection title="Plans and Pricing" />
      <PricingSection />
      <FAQSection items={FAQ} />
    </StyledPricingPage>
  );
}

export default PricingPage;
